module.exports = __webpack_public_path__ + "static/media/chgry.b8f4dc0f.png";